import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";

interface DialogCloseButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const DialogCloseButton: React.FC<DialogCloseButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      //
      size="small"
      style={{ position: "absolute", top: 2, right: 2 }}
      onClick={onClick}
    >
      <Close fontSize="small" />
    </IconButton>
  );
};

export default DialogCloseButton;
